import { render, staticRenderFns } from "./item_dynamic_university.vue?vue&type=template&id=2ff64f80"
import script from "./item_dynamic_university.vue?vue&type=script&lang=js"
export * from "./item_dynamic_university.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Options: require('/home/ubuntu/containers/hermes_eshop/components/core/options.vue').default,ElementBuilder: require('/home/ubuntu/containers/hermes_eshop/components/core/elementBuilder.vue').default})
